import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectCacheSessionId,
  selectCurrentReportId,
  selectSessionId,
} from "../../../../store/selectors/currentReportSelectors";
import { selectLogQueries } from "../../../../store/selectors/devToolsSelectors";
import {
  selectArguments,
  selectConditions,
  selectSorts,
  selectValues,
} from "../../../../store/selectors/fieldsStateSelectors";
import type {
  BuildChartReportRequest,
  ChartStyleSettings,
  ConditionField,
  DimensionField,
  ReportField,
  SortField,
} from "../../../../../../../../api/types/svTypes.ts";

export default function useRequestConfigBuilder() {
  const conditionsAreaValues = useSelector(selectConditions);
  const argumentsAreaValues = useSelector(selectArguments);
  const valuesAreaValues = useSelector(selectValues);
  const sortingAreaValues = useSelector(selectSorts);
  const reportId = useSelector(selectCurrentReportId);

  const isQueryLoggingActive = useSelector(selectLogQueries);
  const sessionId = useSelector(selectSessionId);
  const cacheSessionId = useSelector(selectCacheSessionId);

  const requestConfig = useMemo(() => {
    const request: BuildChartReportRequest = {
      ...createChartRequest(conditionsAreaValues, argumentsAreaValues, valuesAreaValues, sortingAreaValues),
      reportId: reportId ?? "",
      sessionId,
      cacheSessionId,
      withDrilldown: true,
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [
    conditionsAreaValues,
    argumentsAreaValues,
    valuesAreaValues,
    sortingAreaValues,
    reportId,
    sessionId,
    cacheSessionId,
    isQueryLoggingActive,
  ]);

  return { requestConfig };
}

function createChartRequest(
  conditions: ConditionField[],
  args: DimensionField[],
  values: ReportField[],
  sort: SortField[]
) {
  const result = {
    conditions: conditions.map((c) => c.config),
    arguments: args.map((v) => v.config),
    values: values.map((v) => v.config),
    sort: sort.map((s) => s.config),
    settings: {} as ChartStyleSettings,
  };
  return result;
}
